/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowPrintExampleForConfigurationQueryResponse, GetShowPrintExampleForConfigurationPathParams, GetShowPrintExampleForConfiguration404 } from "../../models/GetShowPrintExampleForConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowPrintExampleForConfigurationUrl({ configurationId }: { configurationId: GetShowPrintExampleForConfigurationPathParams["configurationId"] }) {
  const res = { method: 'GET', url: `/api/v1/configurations/${configurationId}/print-example` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:configurationId/print-example}
 */
export async function getShowPrintExampleForConfiguration({ configurationId }: { configurationId: GetShowPrintExampleForConfigurationPathParams["configurationId"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowPrintExampleForConfigurationQueryResponse, ResponseErrorConfig<GetShowPrintExampleForConfiguration404>, unknown>({ method : "GET", url : getGetShowPrintExampleForConfigurationUrl({ configurationId }).url.toString(), ... requestConfig })  
  return res.data
}